import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { authLogoutAndRedirect } from '../../actions/auth';
import { connect } from 'react-redux';
import { setNewNotifications } from '../../actions/currentUser';

const contextTypes = {
  router: PropTypes.object,
};
class UserMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = { active: false }
    this.onMenuClick = this.onMenuClick.bind(this);
    this.logOut = this.logOut.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.bodyClick = this.bodyClick.bind(this);
  }

  componentDidMount() {
    document.body.addEventListener('click', this.bodyClick, false);
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.bodyClick, false);
  }

  bodyClick(e) {
    // Return if target is a link in the menu. Closing happens elsewhere.
    if (this.node.contains(e.target)) return;
    if (this.state.active) {
      this.toggleMenu(e);
    }
  }

  onMenuClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.toggleMenu(e);
    this.context.router.push(e.currentTarget.pathname);
  }

  toggleMenu() {
    this.setState({ active: !this.state.active });
  }

  logOut(e){
    e.preventDefault();
    this.props.logout();
    const logout = new CustomEvent('logoutSuccessful');
    window.dispatchEvent(logout);
    this.toggleMenu();
  }

  render() {

    const { userName, displayName, avatarUri } = this.props;

    // TODO: Remove absolute path for avatars - @etanlubeck 5.9.17
    let profileImage = (avatarUri) ? avatarUri : this.props.profileImage;
    let userSnapshots         = "/snapshots/users/"+ userName;
    let favoriteLivecams      = "/livecams/members/" + userName;
    const nameToDisplay = (displayName.length > 0) ? displayName : userName;

    return (
      <div
        id="user-menu"
        ref={node => this.node = node}
        className="user-menu-wrapper ml-2 ml-md-0"
        onClick={this.toggleMenu}
      >
        <ul className="user-menu">
          <li className="current-menu-item pl-0 pl-md-3">
            <div className="align-items-center d-flex justify-content-center userblock-wrap">
              <div className="user-name d-none d-md-block">{nameToDisplay}</div>
              <div className="profile-image">
                <img className="img-fluid d-inline-block" src={profileImage} width="50" />
              </div>
            </div>
            <ul className={`user-menu-items ${this.state.active ? 'active' : ''}`}>
              <li className="d-md-none border-bottom p-1"><strong>{nameToDisplay}</strong></li>
              <li><Link to={userSnapshots} onClick={this.onMenuClick}>my snapshots</Link></li>
              <li><Link to={`/members/${userName}`} onClick={this.onMenuClick}>favorite snapshots</Link></li>
              <li><Link to={favoriteLivecams} onClick={this.onMenuClick}>favorite livecams</Link></li>
              <li><Link to={`/members/${userName}`} onClick={this.onMenuClick}>profile page</Link></li>
              <li><Link to={`/members/${userName}/notifications`} onClick={this.onMenuClick}>notifications</Link></li>
              <li><Link to="/accounts/logout" onClick={this.logOut}>logout</Link></li>
            </ul>
          </li>
        </ul>
      </div>
    );
  }

}

UserMenu.contextTypes = contextTypes;

const mapStateToProps = (state) => {
  return {
    commentToken: state.auth.commentToken,
    notificationExceptions: state.uiPreferences.notificationExceptions || [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setNotifications: notifications => dispatch(setNewNotifications(notifications)),
    logout: () => dispatch(authLogoutAndRedirect()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserMenu);
